import { get } from '../Services/http'
import { catchError } from './Error.action'

export const RESELLER_GOOGLE_MAP_LOAD = 'RESELLER_GOOGLE_MAP_LOAD'
export const RESELLER_GOOGLE_MAP_ERROR = 'RESELLER_GOOGLE_MAP_ERROR_ERROR'
export const RESELLER_GOOGLE_MAP_RECEIVE = 'RESELLER_GOOGLE_MAP_RECEIVE'

export const load = () => (dispatch, getState) => {
    return get('/api/resellers')
        .then(response => response.json())
        .then(data => dispatch(receive(data)))
        .catch(ex => dispatch(catchError(ex, error => loadError(error))))
}

export const loadError = error => ({
    type: RESELLER_GOOGLE_MAP_ERROR,
    payload: {
        error,
    }
})

export const receive = data => { 
    return ({
        type: RESELLER_GOOGLE_MAP_RECEIVE,
        payload: {
            reSellers: data,
        },
    });
} 
